import { render } from "./deal-type.vue?vue&type=template&id=48b9c9a1"
import script from "./deal-type.vue?vue&type=script&lang=js"
export * from "./deal-type.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brunocarvalho/Projetos/admin-colegio-encanto-juvenil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__